import { lazyLoad } from 'utils/lazy';

export { MaintenancePageView as MaintenancePage } from './MaintenancePage';

export const SystemMaintenance = lazyLoad(
  () => import('./SystemMaintenance'),
  (module) => module.SystemMaintenancePage
);
